import request from '@/common/request';

// 获取验证码
export async function getUserLoginCode() {
  return request(
    {
      url: '/user/captcha',
      method: 'get',
      responseType: 'blob',
    },
    true,
  );
}
// 用户名密码登录
export async function verifyCode(data) {
	return request({
		url: '/user/login-fail-times',
		method: 'post',
		data,
	});
}
// 用户名密码登录
export async function doPasswordLogin(data) {
  return request({
    url: '/user/login-by-password',
    method: 'post',
    data,
  });
}
// 退出登录
export async function doLogout(params) {
  return request({ url: '/user/logout', method: 'get', params });
}
// 获取用户信息
export async function getUserInfo() {
  return request({ url: '/user/info', method: 'get' });
}